// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Resources } from '@shared/localizations/Resources';
import { BrowserUtils } from '@shared/utils/BrowserUtils';
export function validateWatchlistName(name, existingNames) {
    const trimmedName = name.trim();
    if (trimmedName === '') {
        return Resources.getResource('screen.renameScreen.illegalName');
    }
    if (existingNames.includes(trimmedName)) {
        return (Resources.getResource('screen.rename.alreadyExist.firstPart') +
            `'${name}'` +
            Resources.getResource('screen.rename.alreadyExist.secondPart'));
    }
    if (BrowserUtils.regexpEnd.test(name) ||
        BrowserUtils.regexpText.test(name) ||
        BrowserUtils.regexpSymbol.test(name)) {
        return Resources.getResource('screen.renameScreen.illegalName');
    }
    return null;
}
